import { InviteMemberPost } from '@/features/auth';
import { axios } from '@/lib/axios';

export const APIdeleteMembersFromTenant = (tenantId: string, id: string): Promise<void> => {
    return axios.delete(`/tenant/${tenantId}/user?ids=${id}`);
};
